import { render } from "./PointDesProduitsVendu.vue?vue&type=template&id=1ea684e1&ts=true"
import script from "./PointDesProduitsVendu.vue?vue&type=script&lang=ts"
export * from "./PointDesProduitsVendu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__